import PassCodeContainer from './PassCodePageContainer';

export default PassCodeContainer;
